import React from 'react';
import Link from 'next/link';
import classNames from 'classnames';

import { IReviewsGeneral } from 'api/resort/types';
import { useOTSTranslation } from 'i18n/useOTSTranslation';
import { Stars } from 'components/resort/Stars';
import { Rating } from 'components/resort/Rating';
import { TotalReviews } from 'components/resort/GeneralReviews/TotalReviews';
import { ReactComponent as SvgTr } from 'public/assets/icons/link-triangle.svg';
import { getLocale } from 'i18n/locale';
import { ELocale } from 'i18n/localeEnum';
import { ChoiceBadge } from 'components/common/ChoiceBadge/ChoiceBadge';
import { useSettingsPrefetch } from 'settings/SettingsContext';
import styles from './styles.module.scss';

interface IProps {
  reviewsGeneral: IReviewsGeneral,
  className?: string,
  anchorToReviewForm: string,
  title: string,
}

export const GeneralReviews = ({
  reviewsGeneral,
  className,
  title,
  anchorToReviewForm,
}:IProps) => {
  const { t } = useOTSTranslation('common');
  const prefetch = useSettingsPrefetch();
  const locale = getLocale() as ELocale;

  return (
    <div className={classNames(styles.wrapper, className)}>
      <header>
        <h2 className={styles.title}>{t('resort.reviews.seoTitle', { resort: title })}</h2>
        <div className={styles.totalStars}>
          <span className={classNames('h3', styles.h3, styles.title)}>
            {reviewsGeneral.generalRating.overall
              ? `${t('resort.reviews.total')} (${reviewsGeneral.generalRating.overall.toFixed(1)})`
              : `${t('resort.reviews.total')}`}
          </span>
          <Stars amount={reviewsGeneral.generalRating.overall} />
        </div>
        <div className={styles.description}>
          <ChoiceBadge locale={locale} />
          <div className={styles.text}>{t('resort.reviews.OverallRatingHelpText')}</div>
        </div>
      </header>
      <Rating review={reviewsGeneral.generalRating} className={styles.rating} />
      <TotalReviews totalReviews={reviewsGeneral.totalReviews} />
      <Link
        href={`#${anchorToReviewForm}`}
        scroll={false}
        prefetch={prefetch}
        className={styles.btnOpenForm}
      >
        {t('resort.reviews.rateThisResortTitle')}
        <SvgTr />
      </Link>
    </div>
  );
};
